import React from 'react';

import {
  LegacyText,
  LegacyTextList,
  styled,
  DoneIcon,
  LegacyBox,
  Menu,
  MenuItem,
  IconButton,
  PinIcon,
} from '@gogame/components';

import { CHART_ICONS } from '../icons';

const WithOutValueLabelModeButton = styled(IconButton)`
  &:before,
  &:after {
    content: '';
    width: 2px;
    height: 26px;
    position: absolute;
    transform: rotate(-45deg);
  }
  &:before {
    top: 8px;
    left: 17px;
    background: red; //#686868;
  }
  &:after {
    top: 6px;
    left: 18px;
    background: red; //white;
  }
  &:hover:after {
    background: red; //#f0f0f0;
  }
`;

const Circle = styled('span')`
  background-color: ${({ color }) => color};
  display: inline-flex;
  width: 7px;
  height: 7px;
  border-radius: 50%;
`;

const TypesMenuItem = ({ selectedValue, value, onSelect, title }) => {
  return (
    <MenuItem onClick={() => onSelect(value)}>
      <LegacyBox gutter={8} align={'center'}>
        {selectedValue === value ? <DoneIcon color={'action'} /> : null}
        <LegacyText>{title}</LegacyText>
      </LegacyBox>
    </MenuItem>
  );
};

const ValueLabelCheckbox = ({ checked, onChange }) => {
  return checked ? (
    <IconButton icon={<PinIcon />} onClick={() => onChange(false)} />
  ) : (
    <WithOutValueLabelModeButton
      icon={<PinIcon />}
      onClick={() => onChange(true)}
    />
  );
};

const MixedTypesItem = ({
  value,
  label,
  children,
  onSelect,
  onToggle,
  color,
}) => {
  return (
    <LegacyTextList.Item
      style={{ alignItems: 'center' }}
      affix={<Circle color={color} />}
      suffix={
        <LegacyBox align={'center'}>
          {value !== 'line' ? (
            <ValueLabelCheckbox onChange={(v) => onToggle(v)} checked={label} />
          ) : null}
          <Menu
            anchor={<IconButton icon={CHART_ICONS[value]} />}
            PaperProps={{
              style: {
                minWidth: 112,
              },
            }}
          >
            <TypesMenuItem
              selectedValue={value}
              title={'Line'}
              value={'line'}
              onSelect={onSelect}
            />
            <TypesMenuItem
              selectedValue={value}
              title={'Bar'}
              value={'bar'}
              onSelect={onSelect}
            />
            <TypesMenuItem
              selectedValue={value}
              title={'Dot'}
              value={'scatter'}
              onSelect={onSelect}
            />
          </Menu>
        </LegacyBox>
      }
      verticalAlign={'center'}
      suffixStyles={{
        marginLeft: 'auto',
      }}
      gutter={8}
      ellipsis={true}
    >
      {children}
    </LegacyTextList.Item>
  );
};

export default MixedTypesItem;
